/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-08 17:38:23
 * @LastEditors: SYY 188842798@qq.com
 * @LastEditTime: 2025-06-18 11:30:05
 */
// 统一url管理
export default {
  // login: "/login",
  login_GetUrl: "/api/WxAuth/GetRedirectFullUrl",
  login_GetInfo: "/api/WxAuth/GetUserInfoCallback",

  Banner: "/api/Banner/GetPageList",
  News_List: "/api/News/GetPageList",
  News_Info: "/api/News/GetNewsInfo",
  Common_SelectData: "/api/Common/GetSelectItemsByCodes",
  Department_Tree: "/api/Department/GetDeparmentList",
  Department_List: "/api/Department/GetDepartmentIntroductionPage",
  Department_Info: "/api/Department/Detail",
  Doctor_Types: "/api/Department/GetDoctorNoSourceTypes",
  Doctor_List: "/api/Doctor/GetPage",
  Doctor_Info: "/api/Doctor/GetDoctorInfo",
  Doctor_GetRecommendPage: "/api/Doctor/GetRecommendPage",
  Doctor_GetDoctorPageByDepartmentId: "/api/Doctor/GetDoctorPageByDepartmentId",
  Doctor_WorkDate: "/api/Doctor/GetDoctorWorkDate",
  Doctor_SourceNum: "/api/Doctor/GetDocSourceNum",
  Doctor_Recommend: "/api/Doctor/GetRecommendPage",
  Contact_List: "/api/DiagnosisCard/GetList",
  Contact_Info: "/api/DiagnosisCard/GetDiagnosisPersonInfo",
  Contact_Add: "/api/DiagnosisCard/Add",
  Contact_Edit: "/api/DiagnosisCard/Edit",
  Contact_Del: "/api/DiagnosisCard/RemoveRelation",
  Contact_RegisterHealthCard: "/api/DiagnosisCard/RegisterHealthCard",
  Booking_Info: "/api/CardBooking/GetSureReservationInfo",
  Booking_Add: "/api/CardBooking/Add",
  BookingPaymentModeApi: "/api/CardBooking/AddExemptFromPaymentBookingInfo",
  GetRegistrationList: "/api/CardBooking/GetRegistrationList", // 查询挂号记录
  SignInToQueuingUp: "/api/CardBooking/SignInToQueuingUp", //手动签到排队操作
  Booking_List: "/api/CardBooking/GetPage",
  Booking_Detaile: "/api/CardBooking/GetDetail",
  Booking_Cancel: "/api/CardBooking/UpdateCancelBooking",
  Booking_Pay: "/api/CardBooking/UpdatePayBooking",
  LineUp_List: "/api/PatientLineUp/GetPageList",
  LineUp_Info: "/api/PatientLineUp/GetPatientLineUpInfo",
  InHospital_Info: "/api/MyInHospitalList/GetInHospitalInfo",
  InHospital_List: "/api/MyInHospitalList/GetList",
  InHospital_Detaile: "/api/MyInHospitalList/GetChargeItemPage",
  InHospital_Summary: "/api/MyInHospitalList/GetOutHospitalSummary",
  Bill_List: "/api/MyBill/GetPage",
  Bill_Info: "/api/MyBill/GetBillDetail",
  GetApplyPackageInfo: "/api/MyBill/GetApplyPackageInfo",
  NewOutpatientInfo: "/api/MyBill/NewOutpatientInfo",
  UpdateOutPatientInfoState: "/api/MyBill/UpdateOutPatientInfoState",

  GetCheckUpApplyPackageInfo: "/api/MyBill/GetCheckUpApplyPackageInfo",
  NewCheckUpOutpatientInfo: "/api/MyBill/NewCheckUpOutpatientInfo",
  GetSelfItemList: "/api/MyBill/GetSelfItemList",
  AddSelfNewOutpatientInfo: "api/MyBill/AddSelfNewOutpatientInfo",
  Hospital_Info: "/api/Hospital/GetHospitalInfo",
  Pay_Wechat: "/api/WeChatPay/JsApi",
  MobileAggregatePayQuery: "/api/CommonPay/MobileAggregatePayQuery",
  // PayCancel: "/api/CardBooking/CancelBookingInfo",
  // PayCancel: "/api/CommonPay/CancelBookingInfo",
  PayCancel: "/api/WeChatPay/CancelBookingInfo",
  // RefundOutpatientFee: "/api/CommonPay/RefundOutpatientFee",
  RefundOutpatientFee: "/api/WeChatPay/RefundOutpatientFee",
  His_PersonInfo: "/api/HisApi/GetPersonInfoFromHis",
  His_GetAddressList: "/api/HisApi/GetAddressList",
  Comment_Hospital_Add: "/api/Comment/AddHospitalComment",
  VerifyCardBind: "api/DiagnosisCard/VerifyCardBind",
  MyReport_List: "/api/MyReport/Page",
  MyReport_InHospitalPage: "/api/MyReport/InHospitalPage",
  MyReport_Detail: "/api/MyReport/GetExamReportDetail",
  MyReport_InspectionDetail: "/api/MyReport/GetInspectionReportDetail",
  SelfAddNewDiagnosisCard: "/api/DiagnosisCard/SelfAddNewDiagnosisCard",
  SetIsDefaultCard: "/api/DiagnosisCard/SetIsDefaultCard",
  GetWxSystemParameterInfo: "api/WxAuth/GetWxSystemParameterInfo",
  GoodsPrice_GetPhType: "/api/GoodsPriceSelect/GetPhType",
  GoodsPrice_GetGoodsList: "/api/GoodsPriceSelect/GetGoodsList",

  // 流行病筛查表 start
  GetScreeningForm_InfoAsync: "/api/ScreeningForm/GetScreeningFormInfo", //查询流行病筛查表信息
  AddScreeningForm_RecordAsync: "/api/ScreeningForm/AddScreeningFormRecord", //新增流行病筛查表记录
  GetScreeningForm_RecordInfo: "/api/ScreeningForm/GetScreeningFormRecordInfo", //查询就诊人当天筛查表填写记录,
  getDefaultFormInfo: "/api/ScreeningForm/GetDefaultFormInfo",
  AddFormRecordInfo: "/api/ScreeningForm/AddFormRecordInfo",
  GetFormRecordInfoById: "/api/ScreeningForm/GetFormRecordInfoById",
  GetFormRecordInfoFromWx: "/api/ScreeningForm/GetFormRecordInfoFromWx",
  // 流行病筛查表 end
  HospitalOutpatientPay: "/api/CommonPay/HospitalOutpatientPay",
  OurHospitalNewOutpatientInfo: "/api/MyBill/OurHospitalNewOutpatientInfo",
  HospitalNewOutpatientFreeInfo: "/api/MyBill/HospitalNewOutpatientFreeInfo",
  MyElectricBillPage: "/api/MyElectricBill/GetPage",
  MyElectricBillGetDetail: "/api/MyElectricBill/GetDetail",
  GetPersonInfoFromHealthCard: "/api/DiagnosisCard/GetPersonInfoFromHealthCard",
  SendMsg: "/api/DiagnosisCard/SendMsg",
  CheckMsgCode: "/api/DiagnosisCard/CheckMsgCode",
  GetThirdPartReportUrl: "/api/MyReport/GetThirdPartReportUrl",
};
